import React, { useState, useEffect } from "react";
import { debounce, classList } from "../../../utils";
import { Icon } from "@mui/material";
import { IconButton } from "@mui/material";
import { NavLink } from "react-router-dom";
import ScrollTo from "../../common/ScrollTo";
import { Button, Modal, Box } from "@mui/material";
import { getAuthInfo, cleanAuthInfo } from "../../storage";
import './navbar.css';

const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined' && window.innerWidth < breakpoint
    );

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [breakpoint]);

    return isMobile;
};

const Navbar = (props) => {
    const [isTop, setIsTop] = useState(true);
    const [isLogged, setIsLogged] = useState(false);
    const [isClosed, setIsClosed] = useState(true);
    const [languageModalOpen, setLanguageModalOpen] = useState(false);
    const isMobile = useIsMobile();

    const isExternal = (props.isExternal === undefined) ? false : props.isExternal

    useEffect(() => {
        let user = getAuthInfo()
        if (user.email) {
            setIsLogged(true)
        }

    }, []);

    useEffect(() => {
        if (isMobile) {
            setLanguageModalOpen(true);
        }
    }, [isMobile]);

    const handleLogout = () => {
        cleanAuthInfo();
        props.history.push('/login');
    }

    let scrollableElement = document.querySelector(".scrollable-content");
    if (!scrollableElement) scrollableElement = window;

    let handleScrollRef = null;
    let toggleIcon = isClosed ? "menu" : "close";

    const handleScroll = () => {
        return debounce(({ target: { scrollTop } }) => {
            let isCurrentTop = scrollTop < 100 || scrollableElement.scrollY < 100;
            setIsTop(isCurrentTop);
        }, 20);
    };

    handleScrollRef = handleScroll();

    const close = () => {
        setIsClosed(true);
    };

    useEffect(() => {
        if (scrollableElement) {
            scrollableElement.addEventListener("scroll", handleScrollRef);
        }

        return () => {
            if (scrollableElement) {
                scrollableElement.removeEventListener("scroll", handleScrollRef);
            }
        };
    }, [scrollableElement, handleScrollRef]);

    return (
        <section
            className={classList({
                header: true,
                "header-fixed": !isTop,
                closed: isClosed,
            })}

        >
            <div className="container header-container header-container-update">
                <div className="brand">
                    <img src="./assets/images/logos/logo-gsa.png" alt="" />
                </div>
                <div className="nav">
                    <ul className="navigation" style={{ fontSize: 12, }}>
                        <li>
                            {
                                (!isExternal) ? <ScrollTo to="intro_gsa" onScroll={close}>
                                    {props.isSpanish ? "Inicio" : "Home"}
                                </ScrollTo> : <NavLink to="/">{props.isSpanish ? "Inicio" : "Home"}</NavLink>
                            }
                        </li>
                        <li>
                            {
                                (!isExternal) ? <ScrollTo to="aboutus_gsa" onScroll={close}>
                                    {props.isSpanish ? "Nosotros" : "About us"}
                                </ScrollTo> : <NavLink to="/">{props.isSpanish ? "Nosotros" : "About us"}</NavLink>
                            }
                        </li>
                        <li>
                            {
                                (!isExternal) ? <ScrollTo to="courses_gsa" onScroll={close}>
                                    {props.isSpanish ? "Cursos" : "Courses"}
                                </ScrollTo> : <NavLink to="/">{props.isSpanish ? "Cursos" : "Courses"}</NavLink>
                            }
                        </li>
                        <li>
                            {
                                (!isExternal) ? <ScrollTo to="admission_gsa" onScroll={close}>
                                    {props.isSpanish ? "Admisión" : "Admission"}
                                </ScrollTo> : <NavLink to="/">{props.isSpanish ? "Admisión" : "Admission"}</NavLink>
                            }
                        </li>
                        <li>
                            {
                                (!isExternal) ? <ScrollTo to="contact_gsa" onScroll={close}>
                                    {props.isSpanish ? "Contacto" : "Contact"}
                                </ScrollTo> : <NavLink to="/">{props.isSpanish ? "Contacto" : "Contact"}</NavLink>
                            }
                        </li>
                        <li>
                            <NavLink
                                to={`https://webapp.divegsa.com/search?lang=${props.isSpanish ? 'es' : 'en'}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button
                                    style={{ fontSize: "9.5px", maxWidth: '100%' }}
                                    className="box-shadow-none px-8 hover-bg-warning"
                                    variant="outlined"
                                    color={(isLogged) ? "primary" : "warning"}
                                >
                                    {props.isSpanish ? "Encontra tu certificacion" : "Find your certification"}
                                </Button>
                            </NavLink>
                        </li>
                        <li>
                            {/* Contenedor para las banderas de idioma */}
                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px', position: 'relative', top: '11px' }}>
                                <img
                                    src="/assets/images/flags/Flag_of_Spain.svg"
                                    alt="Español"
                                    onClick={() => props.setIsSpanish(true)}
                                    style={{
                                        cursor: 'pointer',
                                        marginRight: '5px',
                                        width: '30px',
                                        height: '20px',
                                        border: props.isSpanish ? '2px solid #007bff' : '2px solid transparent',
                                        padding: '1px'
                                    }}
                                />
                                <img
                                    src="/assets/images/flags/flag_us.svg"
                                    alt="English"
                                    onClick={() => props.setIsSpanish(false)}
                                    style={{
                                        cursor: 'pointer',
                                        width: '30px',
                                        height: '20px',
                                        border: !props.isSpanish ? '2px solid #007bff' : '2px solid transparent',
                                        padding: '1px'
                                    }}
                                />
                            </div>
                        </li>
                        <li>
                            <NavLink to="/" >

                            </NavLink>
                        </li>
                    </ul>
                </div>
                <div>
                </div>

                {(isLogged) ?
                    <div className="navigation flex">
                        <NavLink to="/dashboard" className="mr-1">
                            <Button
                                className="box-shadow-none px-8 rounded-l hover-bg-warning capitalize"
                                variant="outlined"
                                color="warning"
                                style={{ fontSize: 11.5, marginTop: 1 }}
                            >
                                Dashboard
                            </Button>
                        </NavLink>
                        <NavLink to="/login">
                            <Button
                                className="box-shadow-none px-8 rounded-r hover-bg-warning capitalize"
                                variant="outlined"
                                color="warning"
                                style={{ fontSize: 11.5, marginTop: 1 }}
                                onClick={() => handleLogout()}
                            >
                                Logout
                            </Button>
                        </NavLink>
                    </div> :
                    <div className="navigation flex">
                        <a
                            target="_blank"
                            href={`https://webapp.divegsa.com/login?lang=${props.isSpanish ? 'es' : 'en'}`}
                            rel="noreferrer"
                            className="mr-1"
                        >
                            <Button
                                className="box-shadow-none px-7 rounded-l hover-bg-primary capitalize"
                                variant="outlined"
                                color="primary"
                                style={{ fontSize: 11.5, marginTop: 1 }}
                            >
                                {props.isSpanish ? "Ingresar" : "Login"}
                            </Button>
                        </a>
                        <a
                            target="_blank"
                            href={`https://webapp.divegsa.com/register?lang=${props.isSpanish ? 'es' : 'en'}`}
                            rel="noreferrer"
                        >
                            <Button
                                className="box-shadow-none px-7 rounded-r hover-bg-primary capitalize"
                                variant="outlined"
                                color="primary"
                                style={{ fontSize: 11.5, marginTop: 1 }}
                            >
                                {props.isSpanish ? "Registrarse" : "Register"}
                            </Button>
                        </a>
                    </div>}
                <IconButton
                    className="header__toggle"
                    onClick={() => {
                        setIsClosed(!isClosed);
                    }}
                >
                    <Icon>{toggleIcon}</Icon>
                </IconButton>

            </div>
            <Modal
                open={languageModalOpen}
                onClose={() => setLanguageModalOpen(false)}
                aria-labelledby="language-selection-modal-title"
                aria-describedby="language-selection-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '80%',
                    maxWidth: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    textAlign: 'center'
                }}>
                    <h2 id="language-selection-modal-title">{props.isSpanish ? "Seleccionar Idioma" : "Select Language"}</h2>
                    <div id="language-selection-modal-description" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <img
                            src="/assets/images/flags/Flag_of_Spain.svg"
                            alt="Español"
                            onClick={() => { props.setIsSpanish(true); setLanguageModalOpen(false); }}
                            style={{
                                cursor: 'pointer',
                                marginRight: '20px',
                                width: '60px',
                                height: '40px',
                                border: props.isSpanish ? '3px solid #007bff' : '3px solid transparent',
                                padding: '2px'
                            }}
                        />
                        <img
                            src="/assets/images/flags/flag_us.svg"
                            alt="English"
                            onClick={() => { props.setIsSpanish(false); setLanguageModalOpen(false); }}
                            style={{
                                cursor: 'pointer',
                                width: '60px',
                                height: '40px',
                                border: !props.isSpanish ? '3px solid #007bff' : '3px solid transparent',
                                padding: '2px'
                            }}
                        />
                    </div>
                </Box>
            </Modal>
        </section>
    );
};

export default Navbar;
